window.addEventListener('load', function () {
  const Swiper = window.Swiper;
  const carousel = document.querySelector('.highlight-products-carousel');

  if (carousel && carousel.querySelectorAll('.listing__item').length > 2) {
    new Swiper('.highlight-products-carousel', {
      direction: 'horizontal',
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 20,
      loop: true,

      pagination: {
        el: '.highlight-products-carousel__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.highlight-products-carousel__navigation .swiper-button-next',
        prevEl: '.highlight-products-carousel__navigation .swiper-button-prev',
      },
      breakpoints: {
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
          slidesPerGroup: 2,
        },
        1080: {
          slidesPerView: 4.2,
          spaceBetween: 40,
          slidesPerGroup: 1,
          centeredSlides: true,
        },

        1320: {
          slidesPerView: 4.2,
          spaceBetween: 80,
          slidesPerGroup: 1,
          centeredSlides: true,
        },
      },
    });
  } else {
    new Swiper('.highlight-products-carousel', {
      direction: 'horizontal',
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 20,
      loop: false,

      pagination: {
        el: '.highlight-products-carousel__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.highlight-products-carousel__navigation .swiper-button-next',
        prevEl: '.highlight-products-carousel__navigation .swiper-button-prev',
      },
      breakpoints: {
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
          slidesPerGroup: 2,
        },
        1080: {
          slidesPerView: 4.2,
          spaceBetween: 40,
          slidesPerGroup: 1,
          centeredSlides: true,
        },

        1320: {
          slidesPerView: 4.2,
          spaceBetween: 80,
          slidesPerGroup: 1,
          centeredSlides: true,
        },
      },
    });
  }
});
